<script>
  import ProductCard from "./ProductCard.svelte";
  import { getResults, RESULTS_PER_PAGE } from "../../modules/searchanise.js";
  import Product from "../../models/Product.js";
  import dispatchEvent from "../../utils/dispatch-event.js";
  import { appliedFacets, selectedFacets, hasAppliedFacets } from "./stores/facets-store.js";
  import { collectionProducts, currentPage, productCount, searchResponse } from "./stores/collection-products-store.js";
  import { afterUpdate } from "svelte";
  import { currentSorts } from "./stores/sort-order-store";
  import CollectionPagination from "./CollectionPagination.svelte";
  import FeaturedProductCard from "./FeaturedProductCard.svelte";
  import { onMount } from "svelte";
  import { loop_guard } from "svelte/internal";

  export let collection;
  export let query;
  export let featuredProduct;
  export let featuredProductImage;
  export let featuredProductVideo;
  export let featuredProductShopifyVideo;

  let featuredProductData;
  let columns = 2;

  $collectionProducts;

  function onSelectedFacetsChange(selected) {
    currentPage.set(1);
    getProducts();

    if(featuredProduct !== null) {
      featuredProductData = Product.fromShopify(featuredProduct)
    }
  }

  function onCurrentSortsChange(current) {
    currentPage.set(1);
    getProducts();

    if(featuredProduct !== null) {
      featuredProductData = Product.fromShopify(featuredProduct)
    }
  }

  function onCurrentPageChange(page) {
    getProducts(page);
  }

  $: onSelectedFacetsChange($selectedFacets);
  $: onCurrentSortsChange($currentSorts);
  $: onCurrentPageChange($currentPage);

  afterUpdate(() => {
    if ($productCount > 0) {
      document.querySelector("[data-ghost=\"products\"]")?.remove();
    }
  });

  async function getProducts(page = 1) {
    return await getResults({
      collection: collection?.handle || null,
      q: query,
      startIndex: page === 1 ? 0 : ((page - 1) * RESULTS_PER_PAGE),
      sortBy: $currentSorts.sortBy || "relevance",
      sortOrder: $currentSorts.sortOrder,
      ...$appliedFacets
    }).then(data => {
      searchResponse.set(data);

      let currentProducts = [];

      if (page > 1) {
        currentProducts = $collectionProducts;
      }

      collectionProducts.set(
        [...new Set([
          ...currentProducts,
          ...data.items.map(product => Product.fromSearchanise(product))
        ])]
      );

      dispatchEvent("searchanise:products-loaded", document);

      return data;
    });
  }

  let resultsPromise = getProducts();


</script>

<section class="mb-5" data-cy="collection-grid">
  <div class="wrapper flex lg:hidden items-center justify-end mb-2.5" data-grid-selector>
    <span class="mr-1.5">{$productCount} items</span>

    <div
      class="w-1.5 h-1.5 border border-black {columns === 1 ? 'bg-black' : ''} mr-1"
      on:click={() => columns = 1}
      on:keypress={() => columns = 1}
    ></div>

    <div
      class="w-1.5 h-1.5 grid grid-cols-2 gap-[2px]"
      on:click={() => columns = 2}
      on:keypress={() => columns = 2}
    >
      {#each Array.from(Array(4).keys()) as i }
        <div class="border border-black {columns === 2 ? 'bg-black' : ''}"></div>
      {/each}
    </div>
  </div>

  {#await resultsPromise then value }
    <div class="
      lg:wrapper
      grid
      {columns === 1 ? 'grid-cols-1' : 'grid-cols-2'}
      lg:grid-cols-4
      gap-1 lg:gap-2
    ">
      {#each Array.from(Array($collectionProducts.length).keys()) as i ($collectionProducts[i].id)}
        {#if i === 4 && featuredProductData && !$hasAppliedFacets}
            <FeaturedProductCard
              product={featuredProductData}
              image="{featuredProductImage}"
              video="{featuredProductVideo}"
              shopify_video="{featuredProductShopifyVideo}"
            />
        {/if}

        <ProductCard
          product="{$collectionProducts[i]}"
          mobileColumnSpan="{columns === 1 ? 2 : 1}"
        />
      {/each}
    </div>
  {/await}

  <CollectionPagination />
</section>
